import axios from "axios"
import md5 from "js-md5";

let ajax = axios.create({
  timeout: 100000
});



//当前时间戳
let timestamp = new Date().getTime()

ajax.interceptors.request.use(config => {
    let num = ''
    for (let i = 0; i < 6; i++) {
      num += Math.floor(Math.random() * 10)
    }
    config.headers = {
      time: timestamp,
      nonce: num,
      sign: md5(timestamp+num),
    }
    return config
  },
  err => {
    return Promise.reject(err)
  })

let downloadFile = async (url, formData, options) => {
  await ajax.post(url, formData, {responseType: 'arraybuffer'}).then(resp => download(resp, options))
}

let getFile = async (url, options) => {
  await ajax.get(url, {responseType: 'blob'}).then(resp => download(resp, options))
}

let download = (resp, options) => {
  let blob = new Blob([resp.data], {type: options.fileType ? options.fileType : 'application/octet-binary'})
  //创建下载的链接
  let href = window.URL.createObjectURL(blob)
  downloadBlob(href, options.fileName)
}

let downloadBlob = (blobUrl, fileName, revokeObjectURL) => {
  let downloadElement = document.createElement('a')
  downloadElement.href = blobUrl
  //下载后文件名
  downloadElement.download = fileName
  document.body.appendChild(downloadElement)
  //点击下载
  downloadElement.click()
  //下载完成移除元素
  document.body.removeChild(downloadElement)
  if (revokeObjectURL == null || revokeObjectURL) {
    //释放掉blob对象
    window.URL.revokeObjectURL(blobUrl)
  }
}

let getDownloadFileUrl = async (url, fileType) => {
  let blob
  await ajax.get(url, {responseType: 'blob'}).then(resp => {
    blob = new Blob([resp.data], {type: fileType ? fileType : 'application/octet-binary'});
  })
  return window.URL.createObjectURL(blob);
}

let getDownloadFileUrlByPost = async (url, data, fileType) => {
  let blob
  await ajax.post(url, data, {responseType: 'blob'}).then(resp => {
    blob = new Blob([resp.data], {type: fileType ? fileType : 'application/octet-binary'});
  })
  return window.URL.createObjectURL(blob);
}

let getDownloadFileBlob = async (url, fileType) => {
  let blob
  await ajax.get(url, {responseType: 'blob'}).then(resp => {
    blob = new Blob([resp.data], {type: fileType ? fileType : 'application/octet-binary'});
  })
  return blob;
}

export default {
  ajax,
  downloadFile,
  getFile,
  getDownloadFileUrl,
  getDownloadFileUrlByPost,
  getDownloadFileBlob,
  downloadBlob
}




// WEBPACK FOOTER //
// ./src/util/ajax.js